<div class="flex justify-center content-center w-full h-screen">
    <div class="flex content-center w-full">
        <agr-signin-form (signInFlux)="loginRedirect()" class="flex flex-col flex-1"/>
    </div>
</div>